import IconButton from "../../base/button/icon_button";
import {Close} from "@mui/icons-material";
import React from "react";
import classnames from "classnames";

const Removable = ({children, onRemove, className, ...props}) => {

    return (
        <div className={`removable-container ${className}`}>
            <IconButton
                className={classnames('removable-container-remove-icon')}
                onPressed={onRemove}
                color={'paper.error'}
            >
                <Close className={'icon small'}/>
            </IconButton>
            {children}
        </div>
    );
}


export default Removable;
